<div class="container-fluid">
    <div class="row">
        <div class="col-md-3">
            <a routerLink="/naac/dvv/criteria6"> <i class="fas fa-long-arrow-alt-left"></i> Go Back</a>
            <nav id="secondary-navigation">
                <!-- Header -->
                <header class="header">
                    <h5>6.2.2</h5>
                </header>
                <!-- /Header -->
                <ul>
                    <li class="one">
                        <a (click)="changeRoute('1')">6.2.2.1 Screen shots of ERP</a>
                    </li>
                    <li class="two">
                        <a (click)="changeRoute('2')">6.2.2.2 ERP documents</a>
                    </li>
                    <li class="three">
                        <a (click)="changeRoute('3')">6.2.2.3 Institutional expenditure</a>
                    </li>
                </ul>
            </nav>
        </div>
        
        <div class="col-md-9">
            <div class="container-fluid pdf">
                <div class="row">
                    <div class="col-12">
                        <div class="card card-body">
                            <h5 class="card-title text-center" *ngIf="heading1">Screen shots of ERP</h5>
                            <h5 class="card-title text-center" *ngIf="heading2">ERP documents</h5>
                            <h5 class="card-title text-center" *ngIf="heading3">Institutional expenditure</h5>
                            <div id="detail" class="text-center">
                                <pdf-viewer [src]="src" [render-text]="true" style="display: block;"
                                    id="list-view"></pdf-viewer>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>